import { Grid as MuiGrid, withStyles } from '@material-ui/core';

export const SaveButtonContainer = withStyles({
  root: { padding: '34px 16px' },
})(MuiGrid);
